<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 12L10.8383 16L10 15.1943L13.3175 12L10 8.80571L10.8383 8L15 12Z" fill="#080828"/>
</svg>
